(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dah-home"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initBookFans() {
    document.querySelectorAll('[data-dah-carousel]').forEach(function (root) {
      if (root.dataset.fanReady === 'yes') return;
      var stage = root.querySelector('[data-dah-track]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.dah-book-carousel__card'));
      var prev = root.querySelector('[data-dah-prev]');
      var next = root.querySelector('[data-dah-next]');
      if (!stage || !cards.length || !prev || !next) return;
      root.dataset.fanReady = 'yes';
      var active = 0;
      var timer;
      var startedX = null, startedY = null, preventNextClick = false;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      function update() {
        cards.forEach(function (card, i) {
          var delta = (i - active + cards.length) % cards.length;
          var pos = delta === 0 ? 'front' : delta === 1 ? 'right' : delta === cards.length - 1 ? 'left' : 'hidden';
          card.dataset.fanPos = pos;
          if (pos === 'hidden') {
            card.setAttribute('aria-hidden', 'true');
            card.tabIndex = -1;
          } else {
            card.removeAttribute('aria-hidden');
            card.tabIndex = 0;
          }
        });
      }
      function go(step) {
        active = (active + step + cards.length) % cards.length;
        update();
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (cards.length < 2 || reduced.matches) return;
        timer = setInterval(function () {
          if (document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
          go(1);
        }, 6000);
      }
      prev.addEventListener('click', function () { go(-1); start(); });
      next.addEventListener('click', function () { go(1); start(); });
      stage.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startedX = e.touches[0].clientX;
        startedY = e.touches[0].clientY;
        stop();
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startedX === null || !e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startedX;
        var dy = e.changedTouches[0].clientY - startedY;
        startedX = null;
        if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          preventNextClick = true;
          go(dx < 0 ? 1 : -1);
          setTimeout(function () { preventNextClick = false; }, 450);
        }
        start();
      }, { passive: true });
      stage.addEventListener('click', function (e) {
        if (preventNextClick) {
          e.preventDefault();
          e.stopPropagation();
          preventNextClick = false;
          return;
        }
        var link = e.target.closest('.dah-book-carousel__card');
        if (!link) return;
        if (link.dataset.fanPos === 'left') { e.preventDefault(); go(-1); }
        if (link.dataset.fanPos === 'right') { e.preventDefault(); go(1); }
      }, true);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      if (reduced.addEventListener) reduced.addEventListener('change', start);
      if (cards.length === 1) { prev.hidden = true; next.hidden = true; }
      update();
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBookFans);
  else initBookFans();
  document.addEventListener('shopify:section:load', initBookFans);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huda-watch-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(){
  document.querySelectorAll('[data-huda-reels]').forEach(function(root){
   if(root.dataset.hudaReelsReady==='yes')return;
   var rail=root.querySelector('[data-huda-rail]'),prev=root.querySelector('[data-huda-prev]'),next=root.querySelector('[data-huda-next]');
   if(!rail||!prev||!next)return;
   root.dataset.hudaReelsReady='yes';
   function slide(dir){
    var item=rail.querySelector('.huda-reels__card');
    if(!item)return;
    var gap=parseFloat(window.getComputedStyle(rail).gap)||15;
    rail.scrollBy({left:(item.getBoundingClientRect().width+gap)*dir,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   }
   prev.addEventListener('click',function(){slide(-1);});
   next.addEventListener('click',function(){slide(1);});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
